import { message } from "antd";
import React, { Component } from "react";
import PromotionRender from "./children/PromotionRender";
import i18n from "../../../../../../locales/i18n";
import { GAPersonalPromotionPageDisplay } from "../../../../ga/personalCenter";

export default class Promotion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      applyLoading: false, //提交优惠码状态
      promotionType: "promoItem", //当前优惠形式: promoItem || discount
    };
  }

  componentDidMount() {
    GAPersonalPromotionPageDisplay()
  }

  /**
   * 控制当前优惠形式
   * @param {string} e radio的虚拟dom对象
   */
  handlePromotionType = e => {
    this.setState({
      promotionType: e.target.value,
    });
  };

  /**
   * 提交优惠码
   * @param {object} data 表单数据
   */
  handleApplyPromotion = data => {
    message.warn(i18n.t("personalCenterSetting:applyPromotionErrorTips"));
  };

  render() {
    return (
      <PromotionRender
        submitting={this.state.applyLoading}
        promotionType={this.state.promotionType}
        handleApplyPromotion={this.handleApplyPromotion}
        handlePromotionType={this.handlePromotionType}
      />
    );
  }
}
